import { useEffect, useState, useRef } from "react";
import api from "../lib/api";

// Polls the auto-reorder draft purchase orders count every 2 minutes.
// Feeds the sidebar badge on Inventario. Zero noise when count=0.

export default function useDraftOrders(restaurantId, intervalMs = 120_000) {
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!restaurantId) {
      setCount(0);
      return;
    }
    let alive = true;
    const load = async () => {
      try {
        const r = await api.getDraftOrdersCount(restaurantId);
        if (!alive) return;
        setCount(r?.count || 0);
      } catch {
        // Silent: badge is a nice-to-have.
      }
    };
    load();
    timerRef.current = setInterval(load, intervalMs);
    return () => {
      alive = false;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [restaurantId, intervalMs]);

  return { count };
}
